<template>
    <div class="user_bank border p-2 mr-1">
        <div class="d-flex justify-content-center mb-3 mt-3 pt-3 pb-3" v-if="is_load">
            <b-spinner variant="success" label="Loading..."></b-spinner>
        </div>

        <div class="chart" v-else>

            <highcharts :options="chartOptions" :highcharts="char3d"></highcharts>
        </div>
    </div>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts3D from 'highcharts/highcharts-3d'
    import Highcharts from 'highcharts'

    Highcharts3D(Highcharts)
    export default {
        name: "money_load",
        props: {


        },
        components: {
            highcharts: Chart
        },

        created () {
            EventBus.$on('change_date',res => {
                this.getStat();
            }) ;
        },
        mounted() {
            this.getStat();
        },

        data() {
            return {
                is_load: true,
                char3d : Highcharts,
                chartOptions: {
                    chart: {
                        type: 'bar',
						options3d: {
							enabled: true,
							alpha: 0,
							beta: 20,
							depth: 80
						},
                    },

                    yAxis: {
                        title: {
                            text: ' '
                        }
                    },



                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                                format: '{point.y:.0f} грн.'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category'
                    },

                    title:
                        {
                            text: this.__t("MONEY_MOVE"),
                            style:
                                {
                                    color: '#000000',
                                    fontSize: '16px',
                                }
                        },
                    series: [{
                        name: 'Year 1800',
                        data: [107, 31]
                    }],
                    credits: {
                        enabled: false
                    },
                },

            }
        },


        methods: {
            async getStat() {
                this.is_load = true;

                await api.post('/internal/user/dashboard/money',{
                        'date' : this.dash_param_date,
                    }
                ).then(({data}) => {
                    if (data.status == "operation_success") {
                        this.chartOptions.series = data.data.series;
                        this.is_load = false;
                    }
                    else {

                    }

                }).catch(err => {
                    this.is_load = true;
                    console.log(err);
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            },

        },
        computed: {
            dash_param_date() {
                return this.$store.state.dashboard.main.date;
            },

        },

    }
</script>

<style scoped>

</style>
